import { useContext, useMemo } from 'react'
import { ContextShell } from '../../../modules/context'
import { Group } from '../../../types'

type UseDataManageGroup = {
  id: Group['id']
  group?: Group
  isGroupTrial: boolean
  isEnabledManagement: boolean
}

export const useDataManageGroup = (): UseDataManageGroup => {
  const { user } = useContext(ContextShell)

  const group = useMemo(() => {
    if (user?.subscription?.subscriptionType === 'individual') {
      return undefined
    }

    return user?.groups?.find((i: Group) => !i.isPending)
  }, [user?.groups, user?.subscription])

  const id = useMemo(() => group?.id, [group])

  const isGroupTrial = useMemo(
    () => !!user?.subscription?.groupPlanFreeTrial,
    [user?.subscription]
  )

  const isEnabledManagement = useMemo(
    () => !!(group && group?.isOwner && !group.isExpired),
    [group]
  )

  return {
    id,
    group,
    isGroupTrial,
    isEnabledManagement
  }
}
